Em.Handlebars.helper 'isNonZero', (context) ->
  value = parseFloat(context)
  return !isNaN(value) && value != 0